/**
 * upload组件demo
 * @description upload组件demo
 * @author mll
 * @date 2020-2-4
 */
import React from 'react';
import { connect } from 'dva';

import { component_tool, framework_tool, utils_tool } from '../../../tool'
let { excelUtils } = utils_tool
let { WizUpload, WizIcon, WizButton, WizTypography, WizCard, WizText, WizBraftEditor } = component_tool;
let { WizContainer } = framework_tool;
let { braftUtils } = WizBraftEditor

class EditorDemo extends WizContainer {

  componentName = 'EditorDemo';

  constructor(props) {
    super(props)
    this.state = {
      editorState: WizBraftEditor.createEditorState(null),
      outputHTML: '',
      htmlContent: ''
    }
  }

  handleChange = (editorState) => {
    this.setState({
      editorState: editorState,
      outputHTML: editorState.toHTML()
    })
  }

  _append = (type) => {
    let _value = '';
    if (type === 'text') {
      _value = '<span style="font-size:32px;color:skyblue;">我是天蓝色的字体</span>'
    }
    if (type === 'blank') {
      _value = '<p><a href="http://www.baidu.com" target="_blank">百度首页</a> </p>'
    }
    if (type === 'link') {
      _value = '<p><a href="http://localhost:3000/#/demo/dataAuthSelect" target="_parent">数据权限demo</a> </p>'
    }
    if (type === 'img') {
      _value = "<p><img src='https://margox.cn/wp-content/uploads/2016/10/FA157E13E8B77E6E11290E9DF4C5ED7D-480x359.jpg' style='height:auto;width:200' /></p>"
    }
    this.setState({
      editorState: braftUtils.ContentUtils.insertHTML(this.state.editorState, _value)
    })
  }

  _renderEditor = () => {
    const extendControls = [
      {
        key: 'custom-button',
        type: 'button',
        text: '按钮',
        onClick: () => { wizNotice.info('被点击了！') }
      }, {
        key: 'custom-dropdown',
        type: 'dropdown',
        text: '下拉组件',
        component: <div style={{ color: '#fff', padding: 10 }}>你好啊！</div>
      }, {
        key: 'custom-modal',
        type: 'modal',
        text: '模态框',
        modal: {
          id: 'my-moda-1',
          title: '你好啊',
          showClose: true,
          confirmable: true,
          children: (
            <div style={{ width: 480, height: 320, padding: 30 }}>
              <button onClick={() => { this._append('text') }}>插入文字</button><br /><br />
              <button onClick={() => { this._append('blank') }}>外部链接🔗</button><br /><br />
              <button onClick={() => { this._append('link') }}>内部链接🔗</button><br /><br />
              <button onClick={() => { this._append('img') }}>插入图片</button><br /><br />
            </div>
          )
        }
      }
    ]
    return (
      <div className="editor-wrapper">
        <WizBraftEditor
          value={this.state.editorState}
          onChange={(e) => { this.handleChange(e) }}
          extendControls={extendControls}
          ref={instance => this.editorInstance = instance}
        />
      </div>
    )
  }

  _outHTML() {
    return (<div className="output-content">{this.state.outputHTML}</div>)
  }

  _preview() {
    log.info('this.state.editorState.toHTML():', this.state.editorState.toHTML())
    return (
      <div id="goods_detail_content" />
    )
  }

  _componentDidUpdate() {
    document.getElementById("goods_detail_content").innerHTML = this.state.editorState.toHTML();
  }

  _render() {
    return (
      <>
        <WizCard title={'预览'} icon='0'>
          {this._preview()}
        </WizCard>
        <WizCard title={'输出内容'} icon='0'>
          {this._outHTML()}
        </WizCard>
        <WizCard title={'富文本编辑器'} icon='0'>
          {this._renderEditor()}
        </WizCard>

      </>
    )
  }

}

const mapStateToProps = (state, ownProps) => {
  return {

  };
};

export default connect(mapStateToProps)(EditorDemo);
